export default __webpack_public_path__ + "static/media/information-circle.d25da9d2.svg";